/**
 * Черга дублів і злиття записів (DAT-07, DAT-08): `/duplicates?entity=<ключ>` — лінивий чанк
 * `platform/merge/DuplicatesPage.tsx`, `/merge/<сутність>?ids=<id>,<id>[,<id>]` — лінивий чанк
 * `platform/merge/MergePage.tsx`. Ключ сутності — лише канонічний (`[a-z][a-z0-9_]*`); `ids` — до 3
 * UUID через кому, решту розбирає сама сторінка (`parseIds`).
 */
import { createRoute } from '@tanstack/react-router';
import { DUPLICATES_PATH } from '../../shell/nav-model.ts';
import { rootRoute } from './root.tsx';

export interface DuplicatesSearch {
  entity?: string;
}

export interface MergeSearch {
  ids?: string;
}

const ENTITY_KEY = /^[a-z][a-z0-9_]{0,62}$/;
/** До 3 UUID через кому з запасом на пробіли. */
const IDS = /^[0-9a-fA-F,\s-]{1,140}$/;

export const duplicatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: DUPLICATES_PATH,
  validateSearch: (search: Record<string, unknown>): DuplicatesSearch =>
    typeof search.entity === 'string' && ENTITY_KEY.test(search.entity)
      ? { entity: search.entity }
      : {},
}).lazy(() => import('../../platform/merge/DuplicatesPage.tsx').then((m) => m.DuplicatesRoute));

export const mergeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/merge/$entity',
  validateSearch: (search: Record<string, unknown>): MergeSearch =>
    typeof search.ids === 'string' && IDS.test(search.ids) ? { ids: search.ids } : {},
}).lazy(() => import('../../platform/merge/MergePage.tsx').then((m) => m.MergeRoute));
